var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForniture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.28 13.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #606060;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.13c.08-.23.14-.47.24-.69.28-.64.82-.96,1.48-1.08.13-.02.19-.05.19-.2,0-1.12-.03-2.24,0-3.37.02-.83.55-1.55,1.42-1.7C3.67.03,4.02,0,4.36,0c3.93,0,7.87,0,11.8,0,.52,0,1.02.09,1.45.43.39.31.63.71.64,1.2.04,1.22.04,2.45.06,3.67l.03.03c.89.09,1.62.68,1.82,1.55.08.36.11.73.12,1.09.02.66,0,1.32,0,1.98,0,.37-.12.7-.49.84-.16.06-.35.07-.54.11,0,.62,0,1.26,0,1.9,0,.57-.42.92-.88.89-.2-.01-.41-.02-.61,0-.44.04-.82-.36-.81-.82.02-.66,0-1.32,0-1.99H3.34c0,.62,0,1.24,0,1.86,0,.14-.01.29-.05.42-.09.3-.4.52-.72.52-.25,0-.5,0-.75,0-.39.01-.78-.33-.77-.77,0-.66,0-1.32,0-2.01-.48.04-.85-.13-1.04-.59,0-1.07,0-2.14,0-3.21ZM18.38,12.91s.02-.02.03-.03v-1.94s-.02-.02-.03-.03h-.7v2.01s0,.02,0,.03c.01,0,.02-.02.03-.02.22,0,.45,0,.67,0ZM1.82,12.91h.7v-2.01h-.73c0,.67,0,1.34,0,2,0,0,0,.02,0,.03,0,0,.02-.01.03-.02ZM3.36,5.23c0-.58.02-1.16,0-1.74-.01-.51.33-.84.84-.84,1.55,0,3.1,0,4.65,0,.17,0,.35.07.5.16.29.17.34.47.34.77,0,.56,0,1.12,0,1.67h.91c0-.08,0-.15,0-.23,0-.57,0-1.14,0-1.7,0-.07.02-.15.05-.22.15-.33.42-.46.78-.46,1.55,0,3.1,0,4.65,0,.07,0,.15,0,.21.02.41.12.63.41.63.86,0,.57,0,1.15,0,1.72h.61c-.03-1.21-.04-2.4-.09-3.6,0-.25-.13-.48-.37-.64-.29-.2-.61-.23-.94-.23-3.99,0-7.99,0-11.98,0-.15,0-.29,0-.43,0-.42.03-.78.2-.94.6-.1.25-.14.54-.14.81-.02.96,0,1.93,0,2.89,0,.06,0,.11,0,.17h.67s.02-.02.03-.03ZM19.37,8.19l.03-.03c0-.28.03-.56,0-.83-.04-.47-.22-.86-.68-1.08-.3-.14-.62-.18-.94-.18-4.64,0-9.28,0-13.92,0-.64,0-1.28,0-1.92.04-.46.02-.93.34-1.09.81-.14.41-.09.83-.1,1.24.01.01.02.02.03.03.05,0,.11,0,.16,0,6.09,0,12.17,0,18.26,0,.05,0,.11,0,.16,0ZM19.43,9H.77v1.12h18.65v-1.12ZM16.15,3.43h-4.75v1.85h4.75v-1.85ZM4.2,3.43v1.85h4.74v-1.85h-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.34,5.34l-.03-.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.33,5.26s.02-.02.03-.03c-.01.01-.02.02-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.76,8.16l.03.03-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.37,8.19l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.41,10.93s-.02-.02-.03-.03c.01.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.38,12.91s.02-.02.03-.03c-.01.01-.02.02-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.8,12.9h.01s0,0,0,0c0,0-.02.01-.03.02,0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.68,12.91s.02,0,.03,0c-.01,0-.02.02-.03.02,0-.01,0-.02,0-.03Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForniture);
export default __webpack_public_path__ + "static/media/forniture.abf175fdd22ce9753b36cac1b6b72be0.svg";
export { ForwardRef as ReactComponent };